<template>
    <svg
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="viewBox"
    >
        <slot></slot>
    </svg>
</template>

<script>
export default {
  name: "SvgWrapper",
    props: {
        viewBox: {
            type: String,
            required: true
        },
        width: {
            type: [Number, String],
            default: "1.25em"
        },
        height: {
            type: [Number, String],
            default: "1em"
        }
    }
}
</script>

<style lang="scss">
svg {
    width: 1.25em;
    height: 1em;
}
</style>